var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ly-simple-icon"},[_c('i',{staticClass:"lc fas fa-circle"}),_vm._v(" "),_c('i',{staticClass:"rc fas fa-circle"}),_vm._v(" "),_c('i',{staticClass:"text far fa-comment-alt"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f7f9a42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/simple-icon.vue
// module id = JAzY
// module chunks = 1